export default __webpack_public_path__ + "static/media/Rustic-charm-topped-with-scopes-for-adventure.9a2c24c4.jpg";